export default function Terms() {
  return (
    <div className="page-container">
      <div className="legal-section-container">
        <div className="support-content">
          <h2>Terms of Service</h2>
          <p>
            <strong>
              Welcome to AirMouse. By downloading or using AirMouse, you agree to these Terms of Service. Please read them carefully. If you do not agree, do not use the app.
            </strong>
          </p>

          <h3>1. License</h3>
          <p>
            AirMouse is licensed, not sold. We grant you a limited, non-exclusive, non-transferable license to install and use AirMouse for personal, non-commercial purposes.
          </p>

          <h3>2. Restrictions</h3>
          <p>
            You agree not to sell, sublicense, distribute, or rent the app.
          </p>
          <p>
            You also agree not to use AirMouse for any unlawful or harmful purposes.
          </p>

          <h3>3. Disclaimer of Warranties</h3>
          <p>AirMouse is provided “as is” and “as available.”</p>
          <p>
            We make no warranties or guarantees, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
          </p>

          <h3>4. Limitation of Liability</h3>
          <p>To the fullest extent permitted by law:</p>
          <p>
            AirMouse and its developer shall not be liable for any damages, including but not limited to loss of data, device malfunction, or issues arising from use of the app.
          </p>
          <p>You use AirMouse at your own risk.</p>

          <h3>6. Changes to Terms</h3>
          <p>
            We may update these Terms of Service from time to time. Updated terms will be posted at this page, and continued use of AirMouse means you accept the updated terms.
          </p>

          <h3>7. Governing Law</h3>
          <p>
            These Terms shall be governed by and interpreted under the laws of [Your State/Country], without regard to conflict of law principles.
          </p>

          <h3>8. Contact Us</h3>
          <p>
            If you have any questions about these Terms, please contact us at:
            <a href="mailto:airmouse.help@gmail.com" className="legal-email-link"> airmouse.help@gmail.com</a>
          </p>
        </div>
      </div>

      <div className="support-container">
        <div className="support-content">
          <h2>Need More Help?</h2>
          <p>If you have additional questions or need further assistance, our support team is here to help.</p>
          <div className="support-email">
            <span className="email-label">Contact us at:</span>
            <a href="mailto:airmouse.help@gmail.com" className="support-email-link">
              airmouse.help@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

